export default __webpack_public_path__ + "static/media/301.fa0bc1cf.jpg";